/** @format */
import axios from 'axios';
import http from 'http';
import https from 'https';

import { addInterceptors } from '@toucan/common/helpers/request-client/interceptors';

const serverBaseURL = `${process.env.SEARCH_SERVICE_PROTOCOL}://${process.env.SEARCH_SERVICE_DOMAIN}:${process.env.SEARCH_SERVICE_PORT}/search-service/`;
const clientBaseURL = '/search-service/';

function createIsomorphicSearchClient() {
    if (typeof window === 'undefined') {
        return createServerSearchClient();
    }

    return createClientSearchClient();
}

function createServerSearchClient() {
    const client = axios.create({
        baseURL: serverBaseURL,
        timeout: 10000,
        httpAgent: new http.Agent({ keepAlive: false }), // this was the default behaviour prior to node 20, see https://github.com/axios/axios/issues/6113
        httpsAgent: new https.Agent({ keepAlive: false }), // this was the default behaviour prior to node 20, see https://github.com/axios/axios/issues/6113
    });

    addInterceptors(client);

    return client;
}

function createClientSearchClient() {
    const client = axios.create({
        baseURL: clientBaseURL,
    });

    addInterceptors(client);

    return client;
}

export const searchClient = createIsomorphicSearchClient();
